import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import Logo from "../assets/images/Logo.png";
import EchoIcon from "../assets/images/echo-plain.png";
import { useSelector } from "react-redux";
const Topnav = () => {
  const userId = useSelector((state) => state?.profileSlice?.profile?.id);
  return (
    <Box
      sx={{
        // In-flow spacer under the fixed 64px AppBar: just clears the bar
        // (4-8px breathing room) so auth/onboarding cards get the vertical
        // space — also keeps the map's 68px top offset (Background.css)
        // flush with where content starts.
        height: {
          xs: "60px",
          sm: "68px",
          md: "68px",
          lg: "68px",
          xl: "72px",
        },
      }}
    >
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: "#f5f9fc",
          zIndex: 9999,
          top: 0,
          left: 0,
          width: "100%",
          height: "64px",
        }}
      >
        <Toolbar
          sx={{
            width: "100%",
            maxWidth: "xl", // Optional: Restrict max width (lg, md, etc.) or remove for full-width
            mx: "auto", // Center content horizontally
            justifyContent: {
              xs: "center",
              sm: "flex-start",
            },
          }}
        >
          {/* Left-aligned logo with spacing */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: { xs: 2, sm: 10, md: 20, lg: 20, xl: "60px" }, // Padding to the left
            }}
          >
            {userId ? (
              <Box
                component="img"
                src={EchoIcon}
                alt="logo"
                sx={{
                  width: 100,
                  marginLeft: "10px",
                  marginTop: "5px",
                }}
              />
            ) : (
              <img alt="" src={Logo} width={200} />
            )}
          </Box>

          {/* Right side content (optional) */}
          <Box>{/* Add your right-side content here */}</Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Topnav;
